import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';

export const useListAvatarAssets = () => {
  const { callEndpoint } = useAPIContext();
  const listAvatarAssets = React.useCallback(async () => {
    try {
      const res = await callEndpoint<AvatarsAPI, 'list-avatar-assets'>('avatars', `/assets`, 'GET');
      if (!res) throw new Error('Respuesta del servidor inesperada');
      return res;
    } catch (error: any) {
      console.error('Error al listar los assets del avatar:', error);
      return null;
    }
  }, [callEndpoint]);

  return { listAvatarAssets };
};
